
import React from 'react';
import { Box, TextField, InputAdornment, Typography, IconButton, Paper } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { colorPrimary } from '../../Styles/Colors';

 

const variantConfigs = {
  'Title/Show Supporting Text': {
    showTitle: true,
    showHelper: true,
    showAction: true,
    showSupporting: true,
  },
  'Title/Hide Supporting Text': {
    showTitle: true,
    showHelper: true,
    showAction: true,
    showSupporting: false,
  },
  'Hide Title/Show Supporting Text': {
    showTitle: false,
    showHelper: true,
    showAction: true,
    showSupporting: true,
  },
  'Hide Title/Hide Supporting Text': {
    showTitle: false,
    showHelper: true,
    showAction: true,
    showSupporting: false,
  },
  'Show Icon': {
    showIcon: true,
    showClear: false,
  },
  'Hide Icon': {
    showIcon: false,
    showClear: true,
  },
};

const ActionButton = ({ onClick }) => (
  <IconButton
    onClick={onClick}
    sx={{
      background: colorPrimary,
      color: '#fff',
      borderRadius: "4px",
      padding: '0 24px',
      height: 48,
      minWidth: 80,
      fontSize: 16,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': { background: '#7a2a6a' },
    }}
  >
    Action
  </IconButton>
);


const AlternateSearchBars = ({
  variant = 'Title/Show Supporting Text',
  value = '',
  onChange,
  onAction,
  onClear,
  placeholder = 'Search projects',
  title = 'Title',
  helper = 'Helper text',
  supporting = 'Supporting text',
  ...props
}) => {
  // For icon/clear variants
  if (variant === 'Show Icon' || variant === 'Hide Icon') {
    const config = variantConfigs[variant];
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: 320 }}>
        <TextField
          variant="outlined"
          fullWidth
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          InputProps={{
            startAdornment: config.showIcon ? (
              <InputAdornment position="start">
                <SearchIcon color="action" />
              </InputAdornment>
            ) : null,
            endAdornment: config.showClear ? (
              <InputAdornment position="end">
                <IconButton onClick={onClear} size="small">
                  <CloseIcon />
                </IconButton>
              </InputAdornment>
            ) : null,
            sx: {
              borderRadius: 2,
              background: '#fff',
            },
          }}
        />
      </Box>
    );
  }

 
  const config = variantConfigs[variant] || variantConfigs['Title/Show Supporting Text'];
  return (
    <Paper elevation={0} sx={{   width: 400 }} {...props}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        {config.showTitle && (
          <Typography variant="subtitle2" sx={{ color: '#21191e', fontWeight: 600 }}>
            {title}
          </Typography>
        )}
        {config.showHelper && (
          <Typography variant="body2" sx={{ color: '#83727c', fontSize: 14 }}>
            {helper}
          </Typography>
        )}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
          <TextField
            variant="outlined"
            fullWidth
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            InputProps={{
              sx: {
                borderRadius: "4px",
                background: '#fff',
                height: 48,
                fontSize: 16,
                display: 'flex',
                alignItems: 'center',
              },
            }}
          />
          {config.showAction && <ActionButton onClick={onAction} />}
        </Box>
        {config.showSupporting && (
          <Typography variant="caption" sx={{ color: '#bdbdbd', fontSize: 12, mt: 0.5 }}>
            {supporting}
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default AlternateSearchBars;
